<template>
    <div class="relative">
        <!-- Интеграции iiko Card -->
        <CCard>
            <CCardHeader class="flex items-center justify-between">
                <strong>Интеграции iiko Card</strong>
                <CButton color="success" size="sm" @click="createProfile" :disabled="profileSaving">
                    <CSpinner v-if="profileSaving" size="sm" class="mr-1" />
                    Добавить интеграцию
                </CButton>
            </CCardHeader>
            <CCardBody>
                <div v-if="profilesLoading" class="flex items-center gap-2">
                    <CSpinner size="sm" /> Загрузка...
                </div>
                <template v-else>
                    <div class="form-group">
                        <label class="font-medium text-sm">Активная интеграция</label>
                        <select v-model="selectedProfileId" class="form-control" @change="onProfileChange">
                            <option
                                v-for="profile in profiles"
                                :key="profile.id"
                                :value="profile.id">
                                {{ profile.title || profile.app_title || profile.slug }}
                            </option>
                        </select>
                    </div>

                    <div v-if="selectedProfile" class="row mt-3">
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="font-medium text-sm">Название интеграции</label>
                                <CInput v-model="profileForm.title" placeholder="Misha Fisher" class="mb-0" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group">
                                <label class="font-medium text-sm">Slug</label>
                                <CInput v-model="profileForm.slug" placeholder="misha-fisher" class="mb-0" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group mt-4">
                                <label class="flex items-center gap-2 cursor-pointer">
                                    <input type="checkbox" v-model="profileForm.enabled" />
                                    <span class="font-medium text-sm">Показывать карту</span>
                                </label>
                                <label class="flex items-center gap-2 cursor-pointer mt-2">
                                    <input type="checkbox" v-model="profileForm.show_bonus_balance" />
                                    <span class="font-medium text-sm">Показывать баланс бонусов</span>
                                </label>
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">IIKO base URL</label>
                                <CInput v-model="profileForm.base_url" placeholder="https://api-ru.iiko.services/api/" class="mb-0" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">IIKO apiLogin</label>
                                <CInput v-model="profileForm.api_login" placeholder="apiLogin" class="mb-0" />
                            </div>
                        </div>
                        <div class="col-md-4">
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">IIKO organizationId</label>
                                <CInput v-model="profileForm.organization_id" placeholder="organizationId" class="mb-0" />
                            </div>
                        </div>
                    </div>

                    <div class="mt-4 flex justify-end gap-2">
                        <CButton
                            color="danger"
                            variant="outline"
                            @click="deleteProfile"
                            :disabled="profileSaving || !selectedProfileId || profiles.length <= 1">
                            Удалить интеграцию
                        </CButton>
                        <CButton color="primary" @click="saveProfile" :disabled="profileSaving || !selectedProfileId">
                            <CSpinner v-if="profileSaving" size="sm" class="mr-1" />
                            Сохранить интеграцию
                        </CButton>
                    </div>
                </template>
            </CCardBody>
        </CCard>

        <!-- Дизайн карты -->
        <CCard class="mt-4">
            <CCardHeader><strong>Дизайн выбранной iiko Card</strong></CCardHeader>
            <CCardBody>
                <div v-if="designLoading" class="flex items-center gap-2">
                    <CSpinner size="sm" /> Загрузка...
                </div>
                <template v-else>
                    <div class="row">
                        <div class="col-md-6">
                            <div class="form-group">
                                <label class="font-medium text-sm">Заголовок на плитке</label>
                                <CInput v-model="designForm.app_title" placeholder="Скидка в ресторанах" class="mb-0" />
                            </div>
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">Описание на плитке</label>
                                <CInput v-model="designForm.app_description" placeholder="Покажи карту на кассе" class="mb-0" />
                            </div>
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">Подпись под скидкой на плитке</label>
                                <CInput v-model="designForm.app_discount_label" placeholder="Персональная скидка" class="mb-0" />
                            </div>
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">Фон карточки</label>
                                <CInputFile @change="files => uploadDesignFile(files, 'card_bg')" class="mb-1" />
                                <CInput v-model="designForm.card_bg" placeholder="относительный путь или CSS-цвет, напр. #1F3A60" class="mb-0" />
                                <div v-if="designForm.card_bg" class="mt-2 h-10 rounded" :style="cardBgPreviewStyle" />
                            </div>
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">Фон QR-карты</label>
                                <CInputFile @change="files => uploadDesignFile(files, 'qr_bg')" class="mb-1" />
                                <CInput v-model="designForm.qr_bg" placeholder="относительный путь" class="mb-0" />
                                <div v-if="designForm.qr_bg" class="mt-2 iiko-qr-bg-preview rounded" :style="qrBgPreviewStyle" />
                            </div>
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">Цвет текста на QR-карте</label>
                                <div class="flex gap-2 items-center">
                                    <CInput v-model="designForm.qr_text_color" placeholder="#FFFFFF" class="mb-0 flex-1" />
                                    <div
                                        v-if="designForm.qr_text_color"
                                        class="h-8 w-12 rounded border flex-shrink-0"
                                        :style="{ background: designForm.qr_text_color }"
                                    />
                                </div>
                            </div>
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">Логотип</label>
                                <CInputFile @change="files => uploadDesignFile(files, 'image')" class="mb-1" />
                                <CInput v-model="designForm.image" placeholder="относительный путь" class="mb-0" />
                                <img v-if="designForm.image" :src="pictureUrl(designForm.image)" class="mt-2 max-h-16 rounded" />
                            </div>
                        </div>
                        <div class="col-md-6">
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">Текст ERID / реклама (внизу карточки)</label>
                                <textarea v-model="designForm.promo_description" class="form-control" rows="3" placeholder="РЕКЛАМА: ERID% 2VfnnxxRuMul ИНН 876754329987654" />
                            </div>
                            <div class="form-group mt-3">
                                <label class="font-medium text-sm">Ссылка «Подробные условия»</label>
                                <CInput v-model="designForm.conditions_link" placeholder="https://..." class="mb-0" />
                            </div>
                        </div>
                    </div>

                    <hr class="my-3" />
                    <div class="text-sm text-gray-500 mb-3">
                        Подписи на QR-странице по умолчанию (используются, когда у клиента нет активной категории со своим QR-дизайном — см. блок «Категории выбранной iiko Card»).
                    </div>
                    <div class="row">
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="font-medium text-sm">Подпись «Скидка» (слева сверху)</label>
                                <CInput v-model="designForm.qr_discount_label" placeholder="Скидка" class="mb-0" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="font-medium text-sm">Значение скидки (пусто = авто)</label>
                                <CInput v-model="designForm.qr_discount_value" placeholder="Например: 20%" class="mb-0" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="font-medium text-sm">Подпись баланса (справа сверху)</label>
                                <CInput v-model="designForm.qr_balance_label" placeholder="БАЛАНС" class="mb-0" />
                            </div>
                        </div>
                        <div class="col-md-3">
                            <div class="form-group">
                                <label class="font-medium text-sm">Подпись под QR-кодом</label>
                                <CInput v-model="designForm.qr_gift_label" placeholder="Подарочный сертификат" class="mb-0" />
                            </div>
                        </div>
                    </div>

                    <hr class="my-4" />
                    <h5 class="mb-3">Google Wallet</h5>
                    <div class="form-group">
                        <label class="font-medium text-sm d-flex align-items-center">
                            <CSwitch
                                class="mr-2"
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="designForm.google_wallet_enabled"
                            />
                            Разрешить добавление в Google Wallet
                        </label>
                    </div>
                    <div class="form-group mt-3">
                        <label class="font-medium text-sm">Цвет фона</label>
                        <CInput v-model="designForm.google_wallet_bg_color" placeholder="#1F3A60" class="mb-0" />
                        <div class="text-muted small mt-1">
                            HEX-цвет фона карты, например #1F3A60. Если не задан — используется #1F3A60.
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <label class="font-medium text-sm">Логотип карты</label>
                        <CInputFile @change="files => uploadDesignFile(files, 'google_wallet_logo')" class="mb-1" />
                        <CInput v-model="designForm.google_wallet_logo" placeholder="относительный путь" class="mb-0" />
                        <img v-if="designForm.google_wallet_logo" :src="pictureUrl(designForm.google_wallet_logo)" class="mt-2 max-h-16 rounded" />
                        <div class="text-muted small mt-1">
                            Рекомендуемый формат: PNG. Минимальный размер логотипа: 660×660 px (квадрат 1:1).
                            Логотип отображается в круглой маске — оставьте ~15% отступа от краёв, не обрезайте заранее.
                            Если не задан — используется логотип карты (image).
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <label class="font-medium text-sm">Картинка под картой</label>
                        <CInputFile @change="files => uploadDesignFile(files, 'google_wallet_image')" class="mb-1" />
                        <CInput v-model="designForm.google_wallet_image" placeholder="относительный путь" class="mb-0" />
                        <img v-if="designForm.google_wallet_image" :src="pictureUrl(designForm.google_wallet_image)" class="mt-2 max-h-32 rounded" />
                        <div class="text-muted small mt-1">
                            Рекомендуемый формат: PNG. Рекомендуемый размер hero-изображения: 1032×812 px (соотношение ~5:4).
                            Если не задано — картинка в Google Wallet не передаётся.
                        </div>
                    </div>

                    <hr class="my-4" />
                    <h5 class="mb-3">Apple Wallet</h5>
                    <div class="form-group">
                        <label class="font-medium text-sm d-flex align-items-center">
                            <CSwitch
                                class="mr-2"
                                color="dark"
                                shape="pill"
                                variant="opposite"
                                :checked.sync="designForm.apple_wallet_enabled"
                            />
                            Разрешить добавление в Apple Wallet
                        </label>
                    </div>
                    <div class="form-group mt-3">
                        <label class="font-medium text-sm">Цвет фона</label>
                        <CInput v-model="designForm.apple_wallet_bg_color" placeholder="#1F3A60" class="mb-0" />
                        <div class="text-muted small mt-1">
                            HEX-цвет фона карты, например #1F3A60. Если не задан — используется #1F3A60.
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <label class="font-medium text-sm">Логотип карты</label>
                        <CInputFile @change="files => uploadDesignFile(files, 'apple_wallet_logo')" class="mb-1" />
                        <CInput v-model="designForm.apple_wallet_logo" placeholder="относительный путь" class="mb-0" />
                        <img v-if="designForm.apple_wallet_logo" :src="pictureUrl(designForm.apple_wallet_logo)" class="mt-2 max-h-16 rounded" />
                        <div class="text-muted small mt-1">
                            Рекомендуемый формат: PNG. Размер логотипа: до 160×50 pt
                            (320×100 px @2x, 480×150 px @3x). Обычно лучше делать уже максимальной ширины.
                            Если не задан — используется логотип карты (image).
                        </div>
                    </div>
                    <div class="form-group mt-3">
                        <label class="font-medium text-sm">Картинка под картой</label>
                        <CInputFile @change="files => uploadDesignFile(files, 'apple_wallet_image')" class="mb-1" />
                        <CInput v-model="designForm.apple_wallet_image" placeholder="относительный путь" class="mb-0" />
                        <img v-if="designForm.apple_wallet_image" :src="pictureUrl(designForm.apple_wallet_image)" class="mt-2 max-h-32 rounded" />
                        <div class="text-muted small mt-1">
                            Рекомендуемый формат: PNG. Размер strip-изображения для store card: 375×123 pt
                            (750×246 px @2x, 1125×369 px @3x). Если не задано — картинка в Apple Wallet не передаётся.
                        </div>
                    </div>

                    <div class="mt-4 flex justify-end">
                        <CButton color="primary" @click="saveDesign" :disabled="designSaving">
                            <CSpinner v-if="designSaving" size="sm" class="mr-1" />
                            Сохранить дизайн
                        </CButton>
                    </div>
                </template>
            </CCardBody>
        </CCard>

        <!-- Все категории iiko -->
        <CCard class="mt-4">
            <CCardHeader class="flex items-center justify-between">
                <strong>Категории выбранной iiko Card</strong>
                <CButton color="primary" size="sm" @click="loadCategories" :disabled="categoriesLoading">
                    <CSpinner v-if="categoriesLoading" size="sm" class="mr-1" />
                    Синхронизировать с iiko
                </CButton>
            </CCardHeader>
            <CCardBody>
                <div v-if="categoriesLoading" class="flex items-center gap-2">
                    <CSpinner size="sm" /> Загрузка...
                </div>
                <div v-else-if="categoriesError" class="text-red-500">{{ categoriesError }}</div>
                <template v-else>
                    <div class="overflow-hidden border border-gray-300 rounded-md">
                        <div class="flex items-center bg-gray-100 text-sm font-bold">
                            <div class="w-10 d-none d-md-block"></div>
                            <div class="w-8 py-2 text-gray-400">№</div>
                            <div class="col py-2">iiko название</div>
                            <div class="col py-2">Название для юзера</div>
                            <!-- <div class="col py-2">Скидка</div> -->
                            <div class="col d-none d-md-block py-2">Активна в iiko</div>
                            <div class="col py-2">Статус</div>
                            <div style="width:110px" class="py-2"></div>
                        </div>
                        <draggable
                            v-model="categories"
                            tag="div"
                            @end="onDragEnd">
                            <div
                                v-for="(item, idx) in categories"
                                :key="item.id"
                                class="flex items-center py-2 border-t border-gray-300">
                                <div class="w-10 d-none d-md-flex justify-center">
                                    <CIcon :height="16" :content="cilCursorMove" style="cursor:move;" />
                                </div>
                                <div class="w-8 text-gray-400 text-sm">{{ idx + 1 }}</div>
                                <div class="col truncate">{{ item.name }}</div>
                                <div class="col truncate">{{ item.title || '—' }}</div>
                                <!-- <div class="col">{{ item.discount_size || '—' }}</div> -->
                                <div class="col d-none d-md-block">{{ item.is_active ? 'Да' : 'Нет' }}</div>
                                <div class="col">
                                    <CBadge :color="item.enabled ? 'success' : 'secondary'">
                                        {{ item.enabled ? 'Вкл' : 'Выкл' }}
                                    </CBadge>
                                </div>
                                <div style="width:110px">
                                    <CButton size="sm" color="info" @click="openEditModal(item)">
                                        Редактировать
                                    </CButton>
                                </div>
                            </div>
                        </draggable>
                    </div>
                </template>
            </CCardBody>
        </CCard>

        <!-- Управление категориями клиента -->
        <CCard class="mt-4">
            <CCardHeader><strong>Управление категориями клиента в выбранной iiko Card</strong></CCardHeader>
            <CCardBody>
                <div class="flex gap-2 mb-4">
                    <CInput
                        v-model="searchPhone"
                        placeholder="+79001234567"
                        class="mb-0 flex-1"
                        @keyup.enter.native="searchCustomer"
                    />
                    <CButton color="primary" @click="searchCustomer" :disabled="customerLoading">
                        <CSpinner v-if="customerLoading" size="sm" class="mr-1" />
                        Найти
                    </CButton>
                </div>

                <div v-if="customerError" class="text-red-500 mb-3">{{ customerError }}</div>

                <template v-if="customer">
                    <div class="mb-3">
                        <strong>{{ customer.name }} {{ customer.surname }}</strong>
                        <span class="text-gray-500 ml-2">{{ customer.phone }}</span>
                        <span class="text-gray-400 ml-2 text-sm">ID: {{ customer.id }}</span>
                    </div>

                    <div class="rounded border border-blue-200 bg-blue-50 p-3 mb-3">
                        <div class="flex flex-wrap items-center justify-between gap-2">
                            <div class="text-sm">
                                <strong>Подключённые интеграции:</strong>
                                {{ assignedCustomerProfileTitles || 'нет' }}
                            </div>
                            <CButton
                                size="sm"
                                color="primary"
                                @click="assignCustomerProfile"
                                :disabled="actionLoading || !selectedProfileId">
                                {{ isSelectedProfileAssigned ? 'Обновить выбранную интеграцию' : 'Подключить выбранную интеграцию' }}
                            </CButton>
                        </div>
                        <div class="text-gray-600 text-xs mt-2">
                            Пользователь может быть подключён к нескольким интеграциям. Отключение скрывает карту только в приложении и не удаляет данные в iiko.
                        </div>
                        <div v-if="assignedCustomerProfiles.length" class="flex flex-wrap gap-2 mt-2">
                            <CButton
                                v-for="profile in assignedCustomerProfiles"
                                :key="profile.id"
                                size="sm"
                                color="secondary"
                                variant="outline"
                                @click="removeCustomerProfile(profile)"
                                :disabled="actionLoading">
                                {{ profile.title || profile.app_title || profile.slug }} ×
                            </CButton>
                        </div>
                    </div>

                    <div class="flex gap-2 mb-3 items-end">
                        <div class="flex-1">
                            <label class="font-medium text-sm mb-1 block">Добавить категорию</label>
                            <select v-model="selectedCategoryId" class="form-control">
                                <option value="">— выберите категорию —</option>
                                <option
                                    v-for="cat in availableToAdd"
                                    :key="cat.id"
                                    :value="cat.iiko_category_id">
                                    {{ cat.name }}
                                </option>
                            </select>
                        </div>
                        <CButton
                            color="success"
                            @click="addCategory"
                            :disabled="!selectedCategoryId || actionLoading">
                            Добавить
                        </CButton>
                    </div>

                    <div v-if="customer.categories && customer.categories.length">
                        <label class="font-medium text-sm mb-1 block">Текущие категории</label>
                        <div class="flex flex-wrap gap-2">
                            <div
                                v-for="cat in customer.categories"
                                :key="cat.id"
                                class="flex items-center gap-1 bg-blue-100 text-blue-800 text-sm px-2 py-1 rounded">
                                <span>{{ cat.name }}</span>
                                <button
                                    class="ml-1 text-blue-400 hover:text-red-500 font-bold"
                                    title="Удалить"
                                    @click="removeCategory(cat.id)">×</button>
                            </div>
                        </div>
                    </div>
                    <div v-else class="text-gray-400 text-sm">Нет категорий</div>
                </template>
            </CCardBody>
        </CCard>

        <!-- Модал редактирования категории -->
        <CModal
            :show.sync="editModal"
            title="Редактировать категорию"
            size="lg"
            :close-on-backdrop="false">
            <template v-if="editingCategory">
                <div class="mb-3">
                    <div class="text-sm text-gray-500 mb-1">iiko: {{ editingCategory.name }}</div>
                    <div class="text-xs text-gray-400">ID: {{ editingCategory.iiko_category_id }}</div>
                </div>

                <div class="form-group">
                    <label class="font-medium text-sm">Название категории для клиента</label>
                    <CInput v-model="editForm.title" placeholder="Например: Скидка 10%" class="mb-0" />
                </div>

                <!-- <div class="form-group mt-3">
                    <label class="font-medium text-sm">Размер скидки</label>
                    <CInput v-model="editForm.discount_size" placeholder='Например: "20" или "10-20"' class="mb-0" />
                </div> -->

                <!-- <div class="form-group mt-3">
                    <label class="font-medium text-sm">Картинка</label>
                    <CInputFile @change="files => uploadCategoryFile(files, 'image')" class="mb-1" />
                    <CInput v-model="editForm.image" placeholder="URL" class="mb-0" />
                    <img v-if="editForm.image" :src="editForm.image" class="mt-2 max-h-20 rounded" />
                </div> -->

                <div class="form-group mt-3">
                    <label class="font-medium text-sm">Описание скидки</label>
                    <textarea
                        v-model="editForm.discount_description"
                        class="form-control"
                        rows="3"
                        placeholder="Краткое описание условий скидки"
                    />
                </div>

                <!-- <div class="form-group mt-3">
                    <label class="font-medium text-sm">Описание рекламной кампании</label>
                    <textarea
                        v-model="editForm.promo_description"
                        class="form-control"
                        rows="3"
                        placeholder="Текст для пользователей о рекламной кампании"
                    />
                </div> -->

                <div class="form-group mt-3">
                    <label class="flex items-center gap-2 cursor-pointer">
                        <input type="checkbox" v-model="editForm.enabled" />
                        <span class="font-medium text-sm">Включена (показывать пользователям)</span>
                    </label>
                </div>

                <!-- QR-дизайн градации по категории -->
                <hr class="my-4" />
                <div class="mb-3">
                    <strong class="text-sm">Градация: свой QR-дизайн для клиентов с этой категорией</strong>
                    <div class="text-xs text-gray-500 mt-1">
                        Если у клиента есть эта категория и здесь указан «Фон QR-страницы» — на карточке в списке и на странице с QR-кодом покажется именно этот дизайн
                        (незаполненные ниже поля просто не отображаются). Приоритет между категориями клиента — по порядку в таблице выше (первая сверху с заполненным
                        «Фон QR-страницы» побеждает). Если оставить «Фон QR-страницы» пустым — для этой категории используется обычный дизайн из блока «Дизайн выбранной iiko Card».
                    </div>
                </div>

                <div class="form-group mt-3">
                    <label class="font-medium text-sm">Фон карточки в списке (относительный путь картинки или CSS-цвет/градиент)</label>
                    <div class="flex gap-2 items-center">
                        <CInputFile @change="files => uploadCategoryFile(files, 'card_bg')" class="mb-0 flex-1" />
                        <CInput v-model="editForm.card_bg" placeholder="#2ECC71 или относительный путь" class="mb-0 flex-1" />
                        <div v-if="editForm.card_bg" class="h-8 w-12 rounded border flex-shrink-0" :style="colorOrImagePreviewStyle(editForm.card_bg)" />
                    </div>
                </div>

                <div class="form-group mt-3">
                    <label class="font-medium text-sm">Фон QR-страницы (относительный путь картинки или CSS-цвет/градиент)</label>
                    <div class="flex gap-2 items-center">
                        <CInputFile @change="files => uploadCategoryFile(files, 'qr_bg')" class="mb-0 flex-1" />
                        <CInput v-model="editForm.qr_bg" placeholder="#2ECC71 или относительный путь" class="mb-0 flex-1" />
                        <div v-if="editForm.qr_bg" class="h-8 w-12 rounded border flex-shrink-0" :style="colorOrImagePreviewStyle(editForm.qr_bg)" />
                    </div>
                </div>

                <div class="form-group mt-3">
                    <label class="font-medium text-sm">Цвет текста на QR-странице</label>
                    <div class="flex gap-2 items-center">
                        <CInput v-model="editForm.qr_text_color" placeholder="#FFFFFF" class="mb-0 flex-1" />
                        <div
                            v-if="editForm.qr_text_color"
                            class="h-8 w-12 rounded border flex-shrink-0"
                            :style="{ background: editForm.qr_text_color }"
                        />
                    </div>
                </div>

                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group mt-3">
                            <label class="font-medium text-sm">Подпись «Скидка» (слева сверху)</label>
                            <CInput v-model="editForm.qr_discount_label" placeholder="Скидка" class="mb-0" />
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group mt-3">
                            <label class="font-medium text-sm">Значение скидки (пусто = авто)</label>
                            <CInput v-model="editForm.qr_discount_value" placeholder="Например: 20%" class="mb-0" />
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group mt-3">
                            <label class="font-medium text-sm">Подпись баланса (справа сверху)</label>
                            <CInput v-model="editForm.qr_balance_label" placeholder="БАЛАНС" class="mb-0" />
                        </div>
                    </div>
                    <div class="col-md-3">
                        <div class="form-group mt-3">
                            <label class="font-medium text-sm">Подпись под QR-кодом</label>
                            <CInput v-model="editForm.qr_gift_label" placeholder="Подарочный сертификат" class="mb-0" />
                        </div>
                    </div>
                </div>

                <!-- Партнёры категории -->
                <hr class="my-4" />
                <div class="d-flex align-items-center justify-content-between mb-3">
                    <strong class="text-sm">Партнёры категории</strong>
                </div>

                <div v-if="partnersLoading" class="flex items-center gap-2 mb-3">
                    <CSpinner size="sm" /> Загрузка...
                </div>
                <template v-else>
                    <!-- Таблица партнёров -->
                    <div v-if="categoryPartners.length" class="overflow-hidden border border-gray-200 rounded-md mb-3">
                        <div class="flex items-center bg-gray-50 text-xs font-bold text-gray-500 border-b border-gray-200 px-2 py-1">
                            <div style="width:20px"></div>
                            <div style="width:30px">#</div>
                            <div class="flex-1">Название</div>
                            <div class="flex-1">Башня</div>
                            <div style="width:70px">Скидка</div>
                            <div style="width:60px">Иконка</div>
                            <div style="width:90px"></div>
                        </div>
                        <draggable
                            v-model="categoryPartners"
                            tag="div"
                            handle=".partner-drag-handle"
                            @end="onPartnerDragEnd">
                            <div
                                v-for="(partner, pIdx) in categoryPartners"
                                :key="partner.id"
                                class="border-t border-gray-200">
                                <!-- Режим просмотра -->
                                <div v-if="editingPartnerId !== partner.id" class="flex items-center px-2 py-2 gap-2">
                                    <div class="partner-drag-handle flex justify-center" style="cursor:move; width:20px">
                                        <CIcon :height="14" :content="cilCursorMove" />
                                    </div>
                                    <div style="width:30px" class="text-gray-400 text-xs">{{ pIdx + 1 }}</div>
                                    <div class="flex-1 text-sm truncate">{{ partner.title || '—' }}</div>
                                    <div class="flex-1 text-sm truncate text-gray-500">{{ partner.base || '—' }}</div>
                                    <div style="width:70px" class="text-sm text-gray-500">{{ partner.discount_size || '—' }}</div>
                                    <div style="width:60px">
                                        <img v-if="partner.icon" :src="pictureUrl(partner.icon)" class="h-8 w-8 object-contain rounded" />
                                        <span v-else class="text-gray-300 text-xs">—</span>
                                    </div>
                                    <div style="width:90px" class="flex gap-1">
                                        <CButton size="sm" color="info" @click="startEditPartner(partner)">✏</CButton>
                                        <CButton size="sm" color="danger" @click="deletePartner(partner.id)">✕</CButton>
                                    </div>
                                </div>
                                <!-- Режим редактирования -->
                                <div v-else class="px-2 py-2 bg-blue-50">
                                    <div class="flex gap-2 mb-2">
                                        <div class="flex-1">
                                            <label class="text-xs text-gray-500">Название</label>
                                            <CInput v-model="editingPartnerForm.title" placeholder="Название партнёра" class="mb-0" size="sm" />
                                        </div>
                                        <div class="flex-1">
                                            <label class="text-xs text-gray-500">Башня</label>
                                            <CInput v-model="editingPartnerForm.base" placeholder="Башня" class="mb-0" size="sm" />
                                        </div>
                                        <div style="width:120px">
                                            <label class="text-xs text-gray-500">Скидка</label>
                                            <CInput v-model="editingPartnerForm.discount_size" placeholder='10 или 10-20' class="mb-0" size="sm" />
                                        </div>
                                    </div>
                                    <div class="mb-2">
                                        <label class="text-xs text-gray-500">Иконка</label>
                                        <div class="flex gap-2 items-center">
                                            <CInputFile @change="files => uploadPartnerIcon(files, 'edit')" class="mb-0 flex-1" />
                                            <CInput v-model="editingPartnerForm.icon" placeholder="относительный путь" class="mb-0 flex-1" />
                                            <img v-if="editingPartnerForm.icon" :src="pictureUrl(editingPartnerForm.icon)" class="h-8 w-8 object-contain rounded border" />
                                        </div>
                                    </div>
                                    <div class="flex gap-2 justify-end">
                                        <CButton size="sm" color="secondary" @click="cancelEditPartner">Отмена</CButton>
                                        <CButton size="sm" color="primary" @click="savePartnerEdit" :disabled="partnerSaving">
                                            <CSpinner v-if="partnerSaving" size="sm" class="mr-1" />
                                            Сохранить
                                        </CButton>
                                    </div>
                                </div>
                            </div>
                        </draggable>
                    </div>
                    <div v-else class="text-gray-400 text-sm mb-3">Партнёры не добавлены</div>

                    <!-- Форма добавления партнёра -->
                    <div v-if="!showAddPartnerForm">
                        <CButton size="sm" color="success" @click="showAddPartnerForm = true">+ Добавить партнёра</CButton>
                    </div>
                    <div v-else class="border border-green-200 rounded-md p-3 bg-green-50">
                        <div class="text-sm font-medium mb-2">Новый партнёр</div>
                        <div class="flex gap-2 mb-2">
                            <div class="flex-1">
                                <label class="text-xs text-gray-500">Название</label>
                                <CInput v-model="newPartnerForm.title" placeholder="Название партнёра" class="mb-0" />
                            </div>
                            <div class="flex-1">
                                <label class="text-xs text-gray-500">Башня</label>
                                <CInput v-model="newPartnerForm.base" placeholder="Башня" class="mb-0" />
                            </div>
                            <div style="width:140px">
                                <label class="text-xs text-gray-500">Скидка</label>
                                <CInput v-model="newPartnerForm.discount_size" placeholder='10 или 10-20' class="mb-0" />
                            </div>
                        </div>
                        <div class="mb-2">
                            <label class="text-xs text-gray-500">Иконка</label>
                            <div class="flex gap-2 items-center">
                                <CInputFile @change="files => uploadPartnerIcon(files, 'new')" class="mb-0 flex-1" />
                                <CInput v-model="newPartnerForm.icon" placeholder="относительный путь" class="mb-0 flex-1" />
                                <img v-if="newPartnerForm.icon" :src="pictureUrl(newPartnerForm.icon)" class="h-8 w-8 object-contain rounded border" />
                            </div>
                        </div>
                        <div class="flex gap-2 justify-end">
                            <CButton size="sm" color="secondary" @click="cancelAddPartner">Отмена</CButton>
                            <CButton size="sm" color="success" @click="createPartner" :disabled="partnerSaving">
                                <CSpinner v-if="partnerSaving" size="sm" class="mr-1" />
                                Добавить
                            </CButton>
                        </div>
                    </div>
                </template>
            </template>

            <template #footer>
                <CButton color="secondary" @click="editModal = false">Отмена</CButton>
                <CButton color="primary" @click="saveCategory" :disabled="saveLoading">
                    <CSpinner v-if="saveLoading" size="sm" class="mr-1" />
                    Сохранить
                </CButton>
            </template>
        </CModal>

        <CElementCover v-if="actionLoading" :opacity="0.6">
            <CSpinner size="sm" />
        </CElementCover>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import { cilCursorMove } from '@coreui/icons';

const DESIGN_MEDIA_FIELDS = [
    'card_bg',
    'qr_bg',
    'image',
    'google_wallet_logo',
    'google_wallet_image',
    'apple_wallet_logo',
    'apple_wallet_image',
];
const CATEGORY_MEDIA_FIELDS = ['image', 'card_bg', 'qr_bg'];

export default {
    components: { draggable },
    data: () => ({
        cilCursorMove,
        // Profiles
        profiles: [],
        profilesLoading: false,
        profileSaving: false,
        selectedProfileId: '',
        profileForm: {
            title: '',
            slug: '',
            enabled: true,
            show_bonus_balance: false,
            base_url: '',
            api_login: '',
            organization_id: '',
        },

        // Design
        designLoading: false,
        designSaving: false,
        designForm: {
            app_title: '',
            app_description: '',
            app_discount_label: '',
            card_bg: '',
            qr_bg: '',
            qr_text_color: '',
            image: '',
            main_text: '',
            main_subtitle: '',
            secondary_text: '',
            promo_description: '',
            conditions_link: '',
            qr_discount_label: '',
            qr_discount_value: '',
            qr_balance_label: '',
            qr_gift_label: '',
            google_wallet_enabled: true,
            google_wallet_bg_color: '',
            google_wallet_logo: '',
            google_wallet_image: '',
            apple_wallet_enabled: true,
            apple_wallet_bg_color: '',
            apple_wallet_logo: '',
            apple_wallet_image: '',
        },

        // Categories
        categories: [],
        categoriesLoading: false,
        categoriesError: null,
        reorderLoading: false,

        searchPhone: '',
        customer: null,
        customerLoading: false,
        customerError: null,

        selectedCategoryId: '',
        actionLoading: false,

        editModal: false,
        editingCategory: null,
        editForm: {
            title: '',
            discount_size: '',
            image: '',
            card_bg: '',
            discount_description: '',
            promo_description: '',
            enabled: true,
            qr_bg: '',
            qr_text_color: '',
            qr_discount_label: '',
            qr_discount_value: '',
            qr_balance_label: '',
            qr_gift_label: '',
        },
        saveLoading: false,

        // Partners
        categoryPartners: [],
        partnersLoading: false,
        showAddPartnerForm: false,
        newPartnerForm: { title: '', base: '', discount_size: '', icon: '' },
        editingPartnerId: null,
        editingPartnerForm: { title: '', base: '', discount_size: '', icon: '' },
        partnerSaving: false,
    }),

    computed: {
        selectedProfile() {
            return this.profiles.find(p => String(p.id) === String(this.selectedProfileId)) || null;
        },
        availableToAdd() {
            const existing = new Set((this.customer?.categories || []).map(c => c.id));
            return this.categories.filter(c => !existing.has(c.iiko_category_id));
        },
        assignedCustomerProfiles() {
            const assignedIds = this.customer?.assignedProfileIds || [];
            return this.profiles.filter(profile => assignedIds.some(id => String(id) === String(profile.id)));
        },
        assignedCustomerProfileTitles() {
            return this.assignedCustomerProfiles
                .map(profile => profile.title || profile.app_title || profile.slug)
                .join(', ');
        },
        isSelectedProfileAssigned() {
            return this.assignedCustomerProfiles.some(profile => String(profile.id) === String(this.selectedProfileId));
        },
        cardBgPreviewStyle() {
            return this.colorOrImagePreviewStyle(this.designForm.card_bg);
        },
        qrBgPreviewStyle() {
            return this.colorOrImagePreviewStyle(this.designForm.qr_bg);
        },
    },

    async created() {
        await this.loadProfiles();
        await Promise.all([this.loadDesign(), this.loadCategories()]);
    },

    methods: {
        isCssValue(value) {
            return typeof value === 'string' && (
                value.startsWith('#') ||
                value.startsWith('rgb') ||
                value.startsWith('hsl') ||
                value.startsWith('linear') ||
                value.startsWith('radial') ||
                value.startsWith('conic')
            );
        },
        pictureUrl(value) {
            if (!value || this.isCssValue(value)) return '';
            if (/^(https?:|data:|blob:)/i.test(value)) return value;
            const base = (process.env.VUE_APP_STATIC_BASE_URL || '').replace(/\/$/, '');
            return `${base}/${String(value).replace(/^\//, '')}`;
        },
        toRelativeMedia(value) {
            if (!value || typeof value !== 'string') return value || '';
            const trimmed = value.trim();
            if (!trimmed || this.isCssValue(trimmed) || /^(data:|blob:)/i.test(trimmed)) return trimmed;

            const base = (process.env.VUE_APP_STATIC_BASE_URL || '').replace(/\/$/, '');
            if (base && (trimmed === base || trimmed.startsWith(`${base}/`))) {
                return trimmed.slice(base.length).replace(/^\//, '');
            }

            if (/^https?:\/\//i.test(trimmed)) {
                try {
                    const path = new URL(trimmed).pathname.replace(/^\/+/, '');
                    const markers = ['static/images/', 'images/', 'public/', 'static/'];
                    for (const marker of markers) {
                        const idx = path.toLowerCase().indexOf(marker);
                        if (idx === -1) continue;
                        const relative = path.slice(idx + marker.length);
                        if (/^\d{4}\/\d{1,2}\/\d{1,2}\//.test(relative)) return relative;
                    }
                } catch (e) {
                    return trimmed;
                }
                return trimmed;
            }

            return trimmed.replace(/^\//, '');
        },
        applyRelativeMedia(form, fields) {
            const next = { ...form };
            fields.forEach(field => {
                if (next[field]) next[field] = this.toRelativeMedia(next[field]);
            });
            return next;
        },
        colorOrImagePreviewStyle(value) {
            if (!value) return {};
            if (this.isCssValue(value)) return { background: value };
            const url = this.pictureUrl(value);
            if (!url) return {};
            const safeUrl = url.replace(/"/g, '\\"');
            return { backgroundImage: `url("${safeUrl}")`, backgroundSize: 'cover', backgroundPosition: 'center' };
        },
        profileParams() {
            return { profile_id: this.selectedProfileId };
        },
        fillProfileForm(profile) {
            this.profileForm = {
                title: profile?.title || '',
                slug: profile?.slug || '',
                enabled: profile?.enabled !== false,
                show_bonus_balance: Boolean(profile?.show_bonus_balance),
                base_url: profile?.base_url || '',
                api_login: profile?.api_login || '',
                organization_id: profile?.organization_id || '',
            };
        },
        async loadProfiles() {
            this.profilesLoading = true;
            try {
                const { data } = await this.axios.get('/iiko-card/profiles');
                this.profiles = data || [];
                if (!this.selectedProfileId && this.profiles.length) {
                    this.selectedProfileId = this.profiles[0].id;
                }
                this.fillProfileForm(this.selectedProfile);
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка загрузки партнёров');
            } finally {
                this.profilesLoading = false;
            }
        },
        async onProfileChange() {
            this.fillProfileForm(this.selectedProfile);
            this.customer = null;
            this.selectedCategoryId = '';
            await Promise.all([this.loadDesign(), this.loadCategories()]);
        },
        async createProfile() {
            this.profileSaving = true;
            try {
                const title = `Новая интеграция ${this.profiles.length + 1}`;
                const { data } = await this.axios.post('/iiko-card/profiles', {
                    title,
                    app_title: title,
                    slug: `iiko-card-${Date.now()}`,
                    enabled: false,
                });
                this.profiles.push(data);
                this.selectedProfileId = data.id;
                this.fillProfileForm(data);
                await Promise.all([this.loadDesign(), this.loadCategories()]);
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка создания интеграции');
            } finally {
                this.profileSaving = false;
            }
        },
        async saveProfile() {
            if (!this.selectedProfileId) return;
            this.profileSaving = true;
            try {
                const { data } = await this.axios.put(`/iiko-card/profiles/${this.selectedProfileId}`, this.profileForm);
                const idx = this.profiles.findIndex(p => p.id === data.id);
                if (idx !== -1) this.$set(this.profiles, idx, data);
                this.fillProfileForm(data);
                this.$root.$emit('showSuccess', 'Интеграция сохранена');
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка сохранения интеграции');
            } finally {
                this.profileSaving = false;
            }
        },
        async deleteProfile() {
            if (!this.selectedProfileId || this.profiles.length <= 1) return;
            const profile = this.selectedProfile;
            const name = profile?.title || profile?.app_title || profile?.slug || 'интеграцию';
            if (!window.confirm(`Удалить iiko Card интеграцию "${name}"?`)) return;

            this.profileSaving = true;
            try {
                await this.axios.delete(`/iiko-card/profiles/${this.selectedProfileId}`);
                this.profiles = this.profiles.filter(p => String(p.id) !== String(this.selectedProfileId));
                this.selectedProfileId = this.profiles[0]?.id || '';
                this.fillProfileForm(this.selectedProfile);
                this.customer = null;
                this.selectedCategoryId = '';
                await Promise.all([this.loadDesign(), this.loadCategories()]);
                this.$root.$emit('showSuccess', 'Интеграция удалена');
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка удаления интеграции');
            } finally {
                this.profileSaving = false;
            }
        },
        async uploadDesignFile(files, field) {
            const file = files[0];
            if (!file) return;
            const formData = new FormData();
            formData.append('file', file);
            try {
                const { data } = await this.axios.post('/files/upload', formData);
                this.designForm[field] = data.filename;
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка загрузки файла');
            }
        },

        async uploadCategoryFile(files, field) {
            const file = files[0];
            if (!file) return;
            const formData = new FormData();
            formData.append('file', file);
            try {
                const { data } = await this.axios.post('/files/upload', formData);
                this.editForm[field] = data.filename;
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка загрузки файла');
            }
        },

        async uploadPartnerIcon(files, target) {
            const file = files[0];
            if (!file) return;
            const formData = new FormData();
            formData.append('file', file);
            try {
                const { data } = await this.axios.post('/files/upload', formData);
                if (target === 'new') {
                    this.newPartnerForm.icon = data.filename;
                } else {
                    this.editingPartnerForm.icon = data.filename;
                }
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка загрузки иконки');
            }
        },

        async loadDesign() {
            if (!this.selectedProfileId) return;
            this.designLoading = true;
            try {
                const { data } = await this.axios.get('/iiko-card/design', {
                    params: this.profileParams()
                });
                if (data && data.id) {
                    this.designForm = this.applyRelativeMedia({
                        app_title: data.app_title || '',
                        app_description: data.app_description || '',
                        app_discount_label: data.app_discount_label || '',
                        card_bg: data.card_bg || '',
                        qr_bg: data.qr_bg || '',
                        qr_text_color: data.qr_text_color || '',
                        image: data.image || '',
                        main_text: data.main_text || '',
                        main_subtitle: data.main_subtitle || '',
                        secondary_text: data.secondary_text || '',
                        promo_description: data.promo_description || '',
                        conditions_link: data.conditions_link || '',
                        qr_discount_label: data.qr_discount_label || '',
                        qr_discount_value: data.qr_discount_value || '',
                        qr_balance_label: data.qr_balance_label || '',
                        qr_gift_label: data.qr_gift_label || '',
                        google_wallet_enabled: data.google_wallet_enabled !== false,
                        google_wallet_bg_color: data.google_wallet_bg_color || '',
                        google_wallet_logo: data.google_wallet_logo || '',
                        google_wallet_image: data.google_wallet_image || '',
                        apple_wallet_enabled: data.apple_wallet_enabled !== false,
                        apple_wallet_bg_color: data.apple_wallet_bg_color || '',
                        apple_wallet_logo: data.apple_wallet_logo || '',
                        apple_wallet_image: data.apple_wallet_image || '',
                    }, DESIGN_MEDIA_FIELDS);
                }
            } catch (e) {
                // silent
            } finally {
                this.designLoading = false;
            }
        },

        async saveDesign() {
            if (!this.selectedProfileId) return;
            this.designSaving = true;
            try {
                this.designForm = this.applyRelativeMedia(this.designForm, DESIGN_MEDIA_FIELDS);
                const { data } = await this.axios.put('/iiko-card/design', {
                    ...this.designForm,
                    profile_id: this.selectedProfileId
                });
                const idx = this.profiles.findIndex(p => p.id === data.id);
                if (idx !== -1) this.$set(this.profiles, idx, data);
                this.$root.$emit('showSuccess', 'Дизайн сохранён');
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка сохранения');
            } finally {
                this.designSaving = false;
            }
        },

        async onDragEnd() {
            const order = this.categories.map((cat, i) => ({ id: cat.id, sort_order: i }));
            this.reorderLoading = true;
            try {
                await this.axios.put('/iiko-card/categories/reorder', { order, profile_id: this.selectedProfileId });
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка сохранения порядка');
                await this.loadCategories();
            } finally {
                this.reorderLoading = false;
            }
        },

        async loadCategories() {
            if (!this.selectedProfileId) return;
            this.categoriesLoading = true;
            this.categoriesError = null;
            try {
                const { data } = await this.axios.get('/iiko-card/categories', {
                    params: this.profileParams()
                });
                this.categories = data;
            } catch (e) {
                this.categoriesError = e?.response?.data?.error || 'Ошибка загрузки категорий';
            } finally {
                this.categoriesLoading = false;
            }
        },

        async openEditModal(category) {
            this.editingCategory = category;
            this.editForm = this.applyRelativeMedia({
                title: category.title || '',
                discount_size: category.discount_size || '',
                image: category.image || '',
                card_bg: category.card_bg || '',
                discount_description: category.discount_description || '',
                promo_description: category.promo_description || '',
                enabled: category.enabled !== false,
                qr_bg: category.qr_bg || '',
                qr_text_color: category.qr_text_color || '',
                qr_discount_label: category.qr_discount_label || '',
                qr_discount_value: category.qr_discount_value || '',
                qr_balance_label: category.qr_balance_label || '',
                qr_gift_label: category.qr_gift_label || '',
            }, CATEGORY_MEDIA_FIELDS);
            this.categoryPartners = [];
            this.showAddPartnerForm = false;
            this.newPartnerForm = { title: '', base: '', discount_size: '', icon: '' };
            this.editingPartnerId = null;
            this.editModal = true;
            await this.loadCategoryPartners(category.id);
        },

        async saveCategory() {
            this.saveLoading = true;
            try {
                this.editForm = this.applyRelativeMedia(this.editForm, CATEGORY_MEDIA_FIELDS);
                const { data } = await this.axios.put(`/iiko-card/categories/${this.editingCategory.id}`, this.editForm);
                const idx = this.categories.findIndex(c => c.id === data.id);
                if (idx !== -1) this.$set(this.categories, idx, data);
                this.editModal = false;
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка сохранения');
            } finally {
                this.saveLoading = false;
            }
        },

        async searchCustomer() {
            if (!this.searchPhone) return;
            this.customerLoading = true;
            this.customerError = null;
            this.customer = null;
            try {
                const { data } = await this.axios.get('/iiko-card/customer', {
                    params: { phone: this.searchPhone, ...this.profileParams() }
                });
                this.customer = data;
                this.selectedCategoryId = '';
            } catch (e) {
                this.customerError = e?.response?.data?.error || 'Клиент не найден';
            } finally {
                this.customerLoading = false;
            }
        },

        async assignCustomerProfile() {
            if (!this.customer || !this.searchPhone || !this.selectedProfileId) return;

            const profileName = this.selectedProfile?.title || this.selectedProfile?.app_title || this.selectedProfile?.slug;
            if (!window.confirm(`Подключить пользователю интеграцию «${profileName}»?`)) return;

            this.actionLoading = true;
            try {
                const { data } = await this.axios.put('/iiko-card/customer/profile', {
                    phone: this.searchPhone,
                    profile_id: this.selectedProfileId,
                });
                const assignedIds = new Set(this.customer.assignedProfileIds || []);
                assignedIds.add(data.profileId);
                this.customer.assignedProfileIds = Array.from(assignedIds);
                this.$root.$emit('showSuccess', 'Интеграция подключена пользователю');
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Не удалось подключить интеграцию пользователя');
            } finally {
                this.actionLoading = false;
            }
        },

        async removeCustomerProfile(profile) {
            if (!this.customer || !this.searchPhone || !profile?.id) return;

            const profileName = profile.title || profile.app_title || profile.slug;
            if (!window.confirm(`Отключить у пользователя интеграцию «${profileName}»?`)) return;

            this.actionLoading = true;
            try {
                await this.axios.delete('/iiko-card/customer/profile', {
                    data: { phone: this.searchPhone, profile_id: profile.id },
                });
                this.customer.assignedProfileIds = (this.customer.assignedProfileIds || [])
                    .filter(id => String(id) !== String(profile.id));
                this.$root.$emit('showSuccess', 'Интеграция отключена у пользователя');
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Не удалось отключить интеграцию пользователя');
            } finally {
                this.actionLoading = false;
            }
        },

        async addCategory() {
            if (!this.selectedCategoryId || !this.customer) return;
            this.actionLoading = true;
            try {
                await this.axios.post(`/iiko-card/customer/${this.customer.id}/category/add`, {
                    categoryId: this.selectedCategoryId,
                    profile_id: this.selectedProfileId,
                });
                await this.searchCustomer();
                this.selectedCategoryId = '';
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка добавления категории');
            } finally {
                this.actionLoading = false;
            }
        },

        async removeCategory(categoryId) {
            if (!this.customer) return;
            this.actionLoading = true;
            try {
                await this.axios.post(`/iiko-card/customer/${this.customer.id}/category/remove`, {
                    categoryId,
                    profile_id: this.selectedProfileId,
                });
                await this.searchCustomer();
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка удаления категории');
            } finally {
                this.actionLoading = false;
            }
        },

        // ─── Partners ──────────────────────────────────────────────────────────

        async loadCategoryPartners(categoryId) {
            this.partnersLoading = true;
            try {
                const { data } = await this.axios.get(`/iiko-card/categories/${categoryId}/partners`);
                this.categoryPartners = (data || []).map(partner => ({
                    ...partner,
                    icon: this.toRelativeMedia(partner.icon || ''),
                }));
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка загрузки партнёров');
            } finally {
                this.partnersLoading = false;
            }
        },

        async createPartner() {
            if (!this.editingCategory) return;
            this.partnerSaving = true;
            try {
                this.newPartnerForm = {
                    ...this.newPartnerForm,
                    icon: this.toRelativeMedia(this.newPartnerForm.icon),
                };
                const { data } = await this.axios.post(
                    `/iiko-card/categories/${this.editingCategory.id}/partners`,
                    this.newPartnerForm
                );
                this.categoryPartners.push(data);
                this.newPartnerForm = { title: '', base: '', discount_size: '', icon: '' };
                this.showAddPartnerForm = false;
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка добавления партнёра');
            } finally {
                this.partnerSaving = false;
            }
        },

        cancelAddPartner() {
            this.showAddPartnerForm = false;
            this.newPartnerForm = { title: '', base: '', discount_size: '', icon: '' };
        },

        startEditPartner(partner) {
            this.editingPartnerId = partner.id;
            this.editingPartnerForm = { title: partner.title || '', base: partner.base || '', discount_size: partner.discount_size || '', icon: partner.icon || '' };
        },

        cancelEditPartner() {
            this.editingPartnerId = null;
            this.editingPartnerForm = { title: '', base: '', discount_size: '', icon: '' };
        },

        async savePartnerEdit() {
            if (!this.editingPartnerId || !this.editingCategory) return;
            this.partnerSaving = true;
            try {
                this.editingPartnerForm = {
                    ...this.editingPartnerForm,
                    icon: this.toRelativeMedia(this.editingPartnerForm.icon),
                };
                const { data } = await this.axios.put(
                    `/iiko-card/categories/${this.editingCategory.id}/partners/${this.editingPartnerId}`,
                    this.editingPartnerForm
                );
                const idx = this.categoryPartners.findIndex(p => p.id === data.id);
                if (idx !== -1) this.$set(this.categoryPartners, idx, data);
                this.editingPartnerId = null;
                this.editingPartnerForm = { title: '', base: '', discount_size: '', icon: '' };
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка сохранения партнёра');
            } finally {
                this.partnerSaving = false;
            }
        },

        async onPartnerDragEnd() {
            const order = this.categoryPartners.map((p, i) => ({ id: p.id, sort_order: i }));
            try {
                await this.axios.put(`/iiko-card/categories/${this.editingCategory.id}/partners/reorder`, { order });
            } catch (e) {
                this.$root.$emit('showError', 'Ошибка сохранения порядка партнёров');
                await this.loadCategoryPartners(this.editingCategory.id);
            }
        },

        async deletePartner(partnerId) {
            if (!this.editingCategory) return;
            try {
                await this.axios.delete(
                    `/iiko-card/categories/${this.editingCategory.id}/partners/${partnerId}`
                );
                this.categoryPartners = this.categoryPartners.filter(p => p.id !== partnerId);
            } catch (e) {
                this.$root.$emit('showError', e?.response?.data?.error || 'Ошибка удаления партнёра');
            }
        },

    },
};
</script>

<style scoped>
.iiko-qr-bg-preview {
    width: 183px;
    height: 100px;
}
</style>
